import { downloadBlobAsFile } from '@libs/file';

import { FEN_STARTING_POSITION } from './constants';
import { winnerToResult } from './formatResults';
import { IColoredArrow, IColoredSquare, IMoveDto, Pgn } from './pgn';
import { ChessWinner } from './types';

export type IDownloadPgnParams = {
  filename: string;
  winner: ChessWinner | null;
  link?: string;
  fen?: string;
  moves: IMoveDto[];
  // game prelude
  prelude?: string;
  coloredSquares?: IColoredSquare[];
  coloredArrows?: IColoredArrow[];
  //
  event?: string;
  site?: string;
  date?: number;
  round?: string;
  white?: string;
  black?: string;
  timeControl?: string;
  mode?: 'OTB' | 'ICS';
  studyName?: string;
  chapterName?: string;
  variant?: string;
};

export function downloadPgn({
  filename,
  winner,
  link,
  fen,
  moves,
  prelude,
  coloredSquares,
  coloredArrows,
  //
  event,
  date,
  site,
  round,
  white,
  black,
  mode,
  studyName,
  chapterName,
  variant,
}: IDownloadPgnParams) {
  const tags: Record<string, string> = {
    Result: winnerToResult(winner),
  };

  if (event) tags.Event = event;
  if (site) tags.Site = site;
  if (date) {
    tags.Date = new Date(date).toISOString().substring(0, 10).replaceAll('-', '.');
  }
  if (round) tags.Round = round;
  if (white) tags.White = white;
  if (black) tags.Black = black;
  if (fen && fen !== FEN_STARTING_POSITION) {
    tags.FEN = fen;
  }
  if (link) tags.Link = link;
  if (mode) tags.Mode = mode;
  if (studyName) tags.StudyName = studyName;
  if (chapterName) tags.ChapterName = chapterName;
  if (variant) tags.Variant = variant;

  const pgn = new Pgn({
    tags,
    moves,
    prelude,
    coloredSquares,
    coloredArrows,
  });
  const blob = new Blob([pgn.serialize()], {
    type: 'application/vnd.chess-pgn',
  });

  downloadBlobAsFile(filename, blob);
}
